/* src/app/quiz/quiz.component.scss */
.content-container {
  position: relative;
}
.content-container .options-container {
  display: flex !important;
  width: 100%;
}
.content-container h2 {
  margin: 0 auto;
  padding: 0;
  font-family: "Campton-SemiBold";
  font-size: 30px;
  font-weight: 600;
  line-height: 1.2;
  letter-spacing: 1px;
  text-align: center;
  color: #ffffff;
}
.distaction-question-type-1 .content-container .list-group {
  margin: 4% auto 0 auto;
}
.distaction-question-type-2 .content-container .list-group {
  margin: 1.25% auto 0 auto;
}
.distaction-question-type-3 .content-container .list-group {
  margin: 4.5% auto 0 auto;
}
.distaction-question-type-4 .content-container .list-group {
  margin: 4% auto 0 auto;
}
.list-group {
  float: left;
  display: block;
}
.list-group.vertical {
  float: none;
  width: 80%;
}
.list-group.vertical .list-group-item {
  float: none;
  top: 0;
  transform: none;
  max-width: 100%;
  text-align: left;
  width: auto;
}
.list-group.vertical .list-group-item .option-indicator {
  display: inline-block;
  height: 32px;
  vertical-align: middle;
}
.list-group.vertical .list-group-item .option-button {
  text-align: left;
  max-width: 90%;
}
.list-group-item {
  float: left;
  width: 25%;
  max-width: 350px;
  transform: translateY(-50%);
  top: 50%;
  padding: 0;
  margin: 0;
  display: block;
  background: none;
  border: none;
  cursor: pointer;
  padding: 20px;
}
.distaction-question-type-4 .list-group-item .image-option,
.distaction-question-type-3 .list-group-item .image-option {
  margin: 10px;
}
.distaction-question-type-4 .list-group-item label,
.distaction-question-type-3 .list-group-item label {
  margin-top: 15%;
}
.list-group-item {
  font-family: "Campton-SemiBold";
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 2px;
  text-align: center;
  color: #ffffff;
}
.option-button {
  min-width: 188px;
  min-height: 42px;
  border-radius: 50px;
  border: solid 4px transparent;
  background-color: transparent;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  line-height: 30px;
  padding: 10px;
  font-family: "Campton-Light";
}
.option-button:hover,
.list-group-item.selected .option-button {
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4);
}
.list-group-item .option-indicator {
  display: block;
  visibility: hidden;
  margin-top: 5px;
}
.list-group-item.selected .option-button.correct,
.list-group-item.selected .image-option.correct {
  border: solid 4px #6ccc09;
}
.list-group-item.selected .option-button.wrong,
.list-group-item.selected .image-option.wrong {
  border: solid 4px #ff495c;
}
.list-group-item.selected .option-indicator {
  visibility: visible;
  opacity: 1;
}
.btn-outline-primary {
  margin-top: 5%;
  visibility: hidden;
  -webkit-transition: opacity 0ms ease-in-out;
  -moz-transition: opacity 0ms ease-in-out;
  -o-transition: opacity 0ms ease-in-out;
  transition: opacity 0ms ease-in-out;
}
.btn-outline-primary.show {
  visibility: visible;
}
.main-image-container img {
  margin-top: 4%;
  width: 20%;
  height: 30%;
}
.distaction-question-type-4 .main-image-container img {
  margin-top: 4%;
  width: auto;
}
.image-option {
  background-size: 110%;
  border-radius: 100%;
  border: solid 4px transparent;
  cursor: pointer;
  width: 176px;
  height: 176px;
  background-color: transparent;
  box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.4);
  background-repeat: no-repeat;
  background-position: center;
}
/*# sourceMappingURL=quiz.component.css.map */
